<template>
  <section>
    <div class="custom-list">
      <div v-for="(mealplan, idx) of mealplans" :key="idx">
        <nutrition-mealplan-record
          :plan="mealplan"
          @showMealPlan="showMealPlan"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import NutritionMealplanRecord from './nutrition-mealplan-record'
export default {
  name: 'nutrition-mealplans',
  components: {
    NutritionMealplanRecord,
  },
  computed: {
    ...mapGetters('nutrition', ['mealplans']),
  },
  methods: {
    showMealPlan(img) {
      this.$emit('showMealPlan', img)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-list {
  width: 100%;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
